import { render, staticRenderFns } from "./ShippingStep.vue?vue&type=template&id=8f8d05ee&scoped=true&lang=pug&"
import script from "./ShippingStep.vue?vue&type=script&lang=js&"
export * from "./ShippingStep.vue?vue&type=script&lang=js&"
import style0 from "./ShippingStep.vue?vue&type=style&index=0&id=8f8d05ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8d05ee",
  null
  
)

export default component.exports